module.exports = __webpack_public_path__ + "static/media/Dr. AJITH.fa1d5e2a.png";